import {formatMoney, htmlToString} from '../../../../core/services/utils/utils';
import type {EnrichedCrossSalePart} from '../types';

function normalizeQuery(query: string): string[] {
    return query.trim().toLowerCase().split(/\s+/).filter(Boolean);
}

function buildPartSearchHaystack(part: EnrichedCrossSalePart, includePrices: boolean): string {
    const chunks: Array<string | number | undefined | null> = [
        part.partNumber,
        part.title,
        part.description ? htmlToString(part.description, 500) : undefined,
        part.relationTypeTitle,
        part.info?.title,
        part.info?.partNo,
        part.info?.rootCategoryName,
        part.info?.leafCategoryName,
        ...(part.info?.codes ?? []),
    ];

    if (includePrices && part.priceInfo) {
        const {newPrice, originalPrice} = part.priceInfo;
        for (const price of [newPrice, originalPrice]) {
            if (price == null) {
                continue;
            }
            chunks.push(String(price));
            chunks.push(formatMoney(price));
        }
    }

    return chunks
        .filter((value) => value != null && String(value).trim().length > 0)
        .join(' ')
        .toLowerCase();
}

export function filterCrossSalesBySearch(
    parts: EnrichedCrossSalePart[],
    query: string,
    options?: {includePrices?: boolean},
): EnrichedCrossSalePart[] {
    const tokens = normalizeQuery(query);
    if (!tokens.length) {
        return parts;
    }

    const includePrices = options?.includePrices ?? true;

    return parts.filter((part) => {
        const haystack = buildPartSearchHaystack(part, includePrices);
        return tokens.every((token) => haystack.includes(token));
    });
}
